import { createFileRoute } from '@tanstack/react-router'
import { FavoritesPage } from '~/features/favorites/components/FavoritesPage'

export const Route = createFileRoute('/{-$locale}/_public/favorites')({
  component: FavoritesPage,
})
